let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1b2Xc")).then(() => parcelRequire('b5voN'));